var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"sigPad\"><div class=\"sig sigWrapper\"><canvas height=\"80\" width=\"477\" class=\"pad\"></canvas></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./directives/freeforms/newSignature/signature.jade
// module id = 346
// module chunks = 0